angular.module('wbDashboard').controller('OverviewSummaryControllerAurea',
    ['$scope', 'User', 'Message',
        'Guidance', 'PlanningService', 'PlanService',
function ($scope, User, Message,
          Guidance, PlanningService, PlanService) {

    $scope.m = Message; //expose message for easier testability

    $scope.pageData = {
        sending: false,
        hoverData: {},
        year: (new Date()).getFullYear(),
        date: (new Date()),
    };

    //recommendations needs updating on every page load since so many factors can affect it
    if (!PlanningService.getRecommendations()) {
        //if it doesn't exist yet, then initial load is incomplete so don't need to reload it
        PlanningService.retrieveRecommendations(true);
    }

    $scope.$watch(function () { return PlanService.user.getAutos(); }, function (autos) {
        $scope.autos = autos;
    });

    $scope.$watchCollection(function () {
        return [User.getMilestones(null, true), User.getOverview()];
    }, function (data) {
        var [milestones, overview] = data;
        if (milestones && overview) {

            $scope.overview = overview;
            $scope.milestones = milestones;

            angular.forEach($scope.milestones, function (ms) {
                if (!ms.metrics.estimated_achievement || ms.status === 300) {
                    ms.metrics.est_status = "never";
                } else if (ms.metrics.value >= ms.target_amount) {
                    ms.metrics.est_status = "complete";
                    // } else if (ms.auto_deposit.amount === 0) {
                    //     ms.metrics.est_status = "paused";
                } else {
                    ms.metrics.est_status = "working";
                }
            });

            if ($scope.overview.pending_initial_account) {
                // Guidance.addManual({
                //     id: "account-pending",
                //     name: "Almost There",
                //     description: "Your account should be fully invested soon. In the meantime, may we suggest inviting your friends?",
                //     ctaButton: "Start Inviting Friends",
                //     link: "invite"
                // });
            } else {
                Guidance.remove('account-pending');
            }
            if (!$scope.overview.user.flags.email_verified) {
                //should show up before account-pending guidance, so should be added after it
                Guidance.addManual({
                    id: "email-verified",
                    name: "Home Stretch",
                    description: `We just sent you a verification email to ${$scope.overview.user.email.replace('@', '<wbr/>@')}. Please click the link in the email to verify. Please check your spam folders if you don't see it.`,
                    ctaButton: "Resend Invite",
                    ctaAction: function (notice) {
                        notice.ctaDisabled = true;
                        notice.ctaButton = "Sending";
                        User.sendVerifyEmail().then(function () {
                            notice.ctaButton = "Sent";
                            Guidance.read(notice.id);
                        }).catch(function () {
                            notice.ctaDisabled = false;
                            notice.ctaButton = "Resend Invite";
                        });
                    },
                    link: "invite",
                    skipButton: "Skip"
                });
            } else {
                Guidance.remove('email-verified');
            }
        }
    });

    //redirect to 'plan' if there is no guidance or recommendations
    var controllerLoadedAt = moment();
    $scope.$watchCollection(function () {
        return [PlanningService.getRecommendations(), Guidance.get()];
    }, function (data) {
        var [recs, guideMsgs] = data;
        if (recs && guideMsgs) {
            if ($scope.overview && $scope.overview.user.is_closed) {
                return;
            }
            if (!recs.length && (!guideMsgs.length || !Guidance.unreadCount)) {
                if (controllerLoadedAt.diff()/-1000 > 1) {
                    //if it's taken longer than a second since the controller has loaded to update the planing
                    //don't bother with the redirect since it can be jarring
                    return;
                }
                if ($scope.$stateParams.page === 'today') {
                    $scope.$state.go("^.plan");
                }
            }
        }
    });

}]);
